$(function () {
  $(document).click(function (event) {
    var clickover = $(event.target);
    var _opened = $("button[aria-expanded='true']").length > 0;
    if (_opened === true && !clickover.hasClass("collection__filter-group-name")
        && !clickover.hasClass("collection__filter-link")
        && !clickover.hasClass("collection__toolbar-item")
        && !clickover.hasClass("hidden-phone")
        && !clickover.hasClass("icon-state__primary")
        && !clickover.hasClass("icon-state__secondary")
        && !clickover.hasClass("header__mobile-nav-toggle")
        && !clickover.hasClass("mobile-menu__nav-link")
        && !clickover.hasClass("mobile-menu__back-button")
        && !clickover.hasClass("value-picker-button")
        && !clickover.hasClass("collection__filter-item-active")
        && !clickover.hasClass("collection__filter-group-subdiv")
        && !clickover.hasClass("hidden-tablet-and-up")
        && !clickover.hasClass("footer__title")
        && !clickover.hasClass("ftr_menu")
        && !clickover.hasClass("form__field--text")
        && !clickover.hasClass("announcement-bar__newsletter-inner")
        && !clickover.hasClass("header__desktop-nav-toggle")
        && !clickover.hasClass("header__desktop-nav-text")
        && !clickover.hasClass("desk_menu")
    ) {
      $("button[aria-expanded='true']").click();
    }
  });
});

(function(){
  var collectionFilterGroup = document.querySelector('.collection__filter-group');
  var collectionFilterCheckboxList = document.querySelector('.collection__filter-checkbox-list');
  if (!collectionFilterGroup || !collectionFilterCheckboxList) return;

  var pressed = false;
  var startx;

  collectionFilterGroup.addEventListener('mousedown', function(e){
    pressed = true;
    startx = e.offsetX - collectionFilterCheckboxList.offsetLeft;
    collectionFilterGroup.style.cursor = 'grabbing';
  });

  collectionFilterGroup.addEventListener('mouseenter', function(){
    collectionFilterGroup.style.cursor = 'grab';
  });

  collectionFilterGroup.addEventListener('mouseleave', function(){
    collectionFilterGroup.style.cursor = 'default';
  });

  collectionFilterGroup.addEventListener('mouseup', function(){
    collectionFilterGroup.style.cursor = 'grab';
  });

  window.addEventListener('mouseup', function(){
    pressed = false;
  });

  collectionFilterGroup.addEventListener('mousemove', function(e){
    if (!pressed) return;
    e.preventDefault();
    var x = e.offsetX;
    collectionFilterCheckboxList.style.left = (x - startx) + 'px';
  });
})();
